export default __webpack_public_path__ + "static/media/img12.05686632.PNG";